function updateWishlistCount() {
    let count = 0;

    // localStorage me sabhi wishlist keys count karo
    for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        if (key.startsWith("wishlist-")) {
            count++;
        }
    }

    // agar count > 0 hai to show karo, warna hide
    if (count > 0) {
        $(".wishlist-count").text(count).show();
    } else {
        $(".wishlist-count").hide();
    }
}


$(".wishlist-icon").on("click", function() {
    let clickedId = this.id;
    let productId = $(this).data("id"); 

    localStorage.setItem(clickedId, productId);

    let wishfillID = localStorage.getItem(clickedId);

    if (wishfillID == productId) {
        $(this).addClass('action');
    }
    updateWishlistCount();
});

$(document).ready(function(){
    $(".wishlist-icon").each(function(){
        let clickedId = this.id;
        let productId = $(this).data("id");
        let wishfillID = localStorage.getItem(clickedId);

        if (wishfillID == productId) {
            $(this).addClass('action');
        }
    });
    updateWishlistCount();
});

document.addEventListener('click', function(e) {
  if (e.target.closest('.qty-increase')) {
    const input = e.target.closest('.product-card__qty').querySelector('.qty-input');
    input.value = parseInt(input.value || '1') + 1;
  }
  if (e.target.closest('.qty-decrease')) {
    const input = e.target.closest('.product-card__qty').querySelector('.qty-input');
    input.value = Math.max(1, parseInt(input.value || '1') - 1);
  }
});
